export const REVIEWS = [
    {
        name: "Frederic Richard",
        rating: 5,
        text: "Un immense merci à l'agence. Face à un dossier de vente particulièrement ardu et semé d'imprévus, l'équipe a fait preuve d'un sérieux, d'une ténacité et d'un calme remarquables. Sans leur expertise et leur engagement total pour résoudre chaque problème, nous aurions certainement abandonné."
    },
    {
        name: "jocelyn stocker",
        rating: 5,
        text: "Parfait, vraiment rien à redire. L'agence a écouté et pris en compte nos critères pour notre premier achat immo, ils nous ont très bien conseillés et accompagnés jusqu'à la signature définitive. Un grand merci pour leur professionnalisme."
    },
    {
        name: "Geoffrey Giunta",
        rating: 5,
        text: "Un grand merci à l'équipe Borbiconi !! Professionnalisme, efficacité, gestion, rapidité, et j’en passe pour cette vente effectuée. Encore merci !"
    },
    {
        name: "remY DUDEK",
        rating: 5,
        text: "L'agence a tout géré, on a eu des nouvelles du dossier en temps et en heures sans pour autant être invasive. Communication et réactivité exemplaire. Bref je recommande vivement. Merci"
    },
    {
        name: "Philippe CORNILLE",
        rating: 5,
        text: "L'équipe est très professionnelle, efficace, à l'écoute et d'une réactivité excellente ce qui vous conforte dans votre choix. Ne pas hésiter, c'est la bonne agence, la vente a été effectuée rapidement."
    },
    {
        name: "Gessina Black",
        rating: 5,
        text: "Super aventure que d'acquérir une maison. Merci à Borbiconi Immobilier pour tout. Une équipe vraiment engagée et au top dans son travail."
    },
    {
        name: "pascal blaise",
        rating: 5,
        text: "Rien à redire... L'agence était toujours disponible pour l'achat de notre maison... on va leur confier la vente de l'ancienne...😁"
    },
    {
        name: "Lydia Giunta",
        rating: 5,
        text: "Un grand Merci à Borbiconi Immobilier pour son professionnalisme !"
    },
    {
        name: "Robert Schanet",
        rating: 5,
        text: "Super agence immobilière. L'équipe est au top et très engagée, ils ont toujours été à l'écoute et nous ont aidés. Très professionnels et très aimables."
    },
    {
        name: "Amelie R.",
        rating: 5,
        text: "Merci beaucoup aux conseillers pour leur investissement, leur professionnalisme, leur réactivité et surtout leur bonne humeur. Je recommande les yeux fermés 😊"
    },
    {
        name: "Marie-José Lapuh",
        rating: 5,
        text: "Très satisfaite de l'agence Borbiconi. Professionnels, prennent du temps, efficaces, disponibles à tous moments, savent mettre en valeur le bien. Je recommande"
    },
    {
        name: "christian roussiaux",
        rating: 5,
        text: "Excellente agence 10/10. Les conseillers sont très professionnels. Malgré un dossier compliqué, tous les problèmes rencontrés ont été maîtrisés avec efficacité."
    },
    {
        name: "Aline P54",
        rating: 5,
        text: "L'équipe est composée de personnes avec qui nous nous sentons tout de suite rassurés. Ils ont su nous guider dans les différentes étapes de notre parcours, et ont bien ciblé nos attentes."
    },
    {
        name: "Christelle Colombo",
        rating: 5,
        text: "Très bonne agence immobilière, les conseillers ont tout fait pour vendre notre maison. Je les recommande, ils sont à l'écoute."
    },
    {
        name: "Tof Inisedep",
        rating: 5,
        text: "L'agence est vraiment professionnelle, disponible et abordable. Ils nous ont accompagnés pour la vente d'une de nos propriétés. Une visite = Vente de la maison."
    },
    {
        name: "Christophe Rouvelin",
        rating: 5,
        text: "Je vous remercie de votre professionnalisme et votre sympathie, encore merci pour votre travail concernant la vente de notre maison et récemment la vente de notre terrain."
    }
];
